import { useEffect, useState } from "react"
import DefaultLayout from "@/components/DefaultLayout"
import styles from "@/styles/writeReview.module.scss"
import { Image, Form, Input, Rate, Checkbox, Radio, Button, message, Row, Skeleton } from "antd"
import Link from "next/link"
import getConfig from "next/config"
import { useRouter } from "next/router"
const { TextArea } = Input;
const { publicRuntimeConfig } = getConfig()
const imageDomain = publicRuntimeConfig.imageDomain
const apiDomain = publicRuntimeConfig.apiDomain
import productApi from '@/service/modules/productApi'
import { localStorageService } from "@/utils/storageService"
import { formatCurrency } from "@/utils/utils"
import { CloseOutlined } from "@ant-design/icons"
import refuseStyles from "@/styles/submitSave.module.scss"
import { useSelector } from "react-redux"
import { RootState } from "@/store/store"
import Head from "next/head"

export default function WriteReview() {
  const router = useRouter();
  const { params }: any = router.query;
  const [orderInfo, setOrderInfo] = useState<any>({})
  const [loading, setLoading] = useState(true)


  useEffect(() => {
    if (router.isReady) {
      const productID = params[0]
      const orderID = params[1]
      let data: { productID: string, orderID?: string } = {
        productID
      }
      if (orderID) {
        data.orderID = orderID
      }
      getDetail(data)
    }
  }, [params])

  const getDetail = async (params: any) => {
    try {
      const res = await productApi.reviewCheck(params)
      const { product } = res.data
      setOrderInfo(product)
      setLoading(false)
    } catch (error: any) {
      message.error(error.message)
      setLoading(false)
    }
  }
  return (
    <>
      <Head>
        <title>
          Online Shopping Australia - Beauty & Health, Computers, Toys, - Deals
          & Discounts | CrazySales
        </title>
        <meta
          name="keywords"
          content="Online Shopping Australia, online shopping sites, Home Shopping, Shopping Deals, Best Deals, Home Garden, Pet Supplies, Sports Fitness, Bedding Bath, Buy Online, Discount Shopping, Toys Hobbies, Beauty Health, Crazy Sales, Computers, IT, Christmas, Electronics, Automotive, Tools, Appliances, Baby, CrazySales"
        ></meta>
        <meta
          name="description"
          content="CrazySales.com.au - Australia's #1 online shopping website! Cheap bargains &amp; discounts with the top online shopping Australia store! From furniture, to toys &amp; hobbies, to appliances &amp; pet supplies -- we've got it all, with free shipping on selected items!"
        ></meta>
      </Head>

      <DefaultLayout>
        {
          loading
            ?
            <Skeleton active style={{ width: '1200px', margin: '24px auto', padding: '38px 0' }} />
            :
            <>
              {
                orderInfo && Object.keys(orderInfo).length > 0
                  ?
                  <WriteReviewForms params={params} router={router} orderInfo={orderInfo} />
                  :
                  <RefuseReviews />
              }
            </>
        }

      </DefaultLayout>
    </>
  )
}

const WriteReviewForms = ({ params, router, orderInfo }: any) => {

  const [form] = Form.useForm()
  const userInfo = useSelector((state: RootState) => state.userInfo.data);
  const [userName, setUserName] = useState<string>('')

  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setUserName(`${userInfo.firstName} ${userInfo.lastName}`)
  }, [userInfo])


  const checkboxChange = (newVal: any) => {
    if (newVal.length > 1) {
      form.setFieldsValue({ nickname: [newVal[newVal.length - 1]] })
    }

  }

  const onFinish = async (formValue: any) => {
    setLoading(true)
    try {
      const { rating, satistied, nickname, title, content, recommend, images } = formValue
      const orderID = params[1] || orderInfo.orderID
      const productID = params[0]
      const data = {
        orderID,
        productID,
        rating,
        satistied,
        nickname: nickname[0],
        title,
        content,
        images: images && images.length > 0 ? images.map((item: any) => ({ ...item.value })) : [],
        recommend
      }

      await productApi.reviewSave(data)
      setLoading(false)
      // router.push(`/review/submit-save/${productID}`)
      window.location.href = `/review/submit-save/${productID}`

    } catch (error: any) {
      message.error(error.message)
      setLoading(false)
    }
  }

  return (
    <div className={styles['main']}>
      <div className={styles['write-review']}>
        <div className={styles['write-review-title']}>Crazysales Product Review System</div>
        <div className={styles['write-review-rule']}>
          <div className={styles['write-review-rule-left']}>
            <Image src={`${imageDomain}/write_review_txt.jpg`} preview={false} width="100%" />
          </div>
          <div className={styles['write-review-rule-right']}>
            <div className={styles['crazy-point-rule']}>
              <div className={styles['crazy-point']}>
                <div className={styles['crazy-point-title']}>
                  <Image src={`${imageDomain}/BestdealPoint.png`} preview={false} width="24px" />
                </div>
                <div className={styles['crazy-point-content']}>
                  100 crazypoints for each approved text review
                </div>
              </div>
              <div className={styles['crazy-point']}>
                <div className={styles['crazy-point-title']}>
                  <Image src={`${imageDomain}/BestdealPoint.png`} preview={false} width="24px" />
                </div>
                <div className={styles['crazy-point-content']}>
                  200 crazypoints for each approved review with text and pictures
                </div>
              </div>
            </div>
            <div className={styles['rule-note']}>
              Note: You will get double crazypoints if your review is one of the first three approved!
            </div>
            <div className={styles['change-ratio']}>
              Earn <span className={styles['red']}>100</span> CrazyPoints for each review! <span className={styles['red']}>100 Crazy Points = $1</span>
            </div>
          </div>
        </div>

        <div className={styles['goods-detail']}>
          <div className={styles['goods-detail-img']}>
            <Link href={orderInfo.url} legacyBehavior>
              <a style={{ display: 'block' }} target="_blank" rel="noopener noreferrer">
                <Image src={orderInfo.defaultFullUrl} width={'100%'} height={'100%'} preview={false} />
              </a>
            </Link>
          </div>
          <div className={styles['goods-detail-info']}>
            <Link href={orderInfo.url} legacyBehavior>
              <a className={styles['goods-detail-info-title']} target="_blank" rel="noopener noreferrer">{orderInfo.productName}</a>
            </Link>
            {/* <div className={styles['goods-detail-info-price']}>
              <div className={styles['price']}>{formatCurrency(orderInfo.price || 0)}</div>
              {
                orderInfo.normalPrice > 0
                &&
                <div className={styles['cross-price']}>{formatCurrency(orderInfo.normalPrice || 0)}</div>
              }
            </div> */}
          </div>
        </div>

        <div className={styles['review-form']}>
          <Form
            form={form}
            name="review-form"
            colon={false}
            onFinish={onFinish}
            initialValues={{
              rating: 5,
              satistied: 5,
              title: '',
              content: '',
              recommend: 1,
              nickname: ['Customer']
            }}
          >
            <div style={{ paddingLeft: '52px' }}>
              <Form.Item
                label={<div className={`${styles['review-form-label']} ${styles['bold']}`}>Overall Rating</div>}
                name="rating"
                rules={[{ required: true, message: "Please input your rating!" }]}
              >
                <Rate defaultValue={5} />
              </Form.Item>

              <Form.Item
                label={<div className={`${styles['review-form-label']} ${styles['bold']}`}>Delivery</div>}
                name="satistied"
                rules={[{ required: true, message: "Please input your rating!" }]}
              >
                <Rate defaultValue={5} />
              </Form.Item>

              <Form.Item
                label={<div className={styles['review-form-label']}>Nickname:</div>}
                name="nickname"
                initialValue={[orderInfo.shippingName]}
              >
                <Checkbox.Group onChange={checkboxChange} style={{ paddingLeft: '11px' }}>
                  <Checkbox value={'Customer'}>{'Customer'}</Checkbox>
                  <Checkbox value={userName}>{userName}</Checkbox>
                </Checkbox.Group>
              </Form.Item>


              <div className={styles['form-tips-box']}>
                <Form.Item
                  label={<div className={styles['review-form-label']}>Title:</div>}
                  name="title"
                  rules={[{ required: true, message: "Please input the Title" }]}
                >
                  <Input placeholder="Please input 10-100 characters" />
                </Form.Item>
                <div className={styles['form-tip']}>{'(Example: I love this item!!!!)'}</div>
              </div>

              <div className={styles['form-tips-box']}>
                <Form.Item
                  label={<div className={styles['review-form-label']}>Content:</div>}
                  name="content"
                  rules={[{ required: true, message: "Please input the Content" }]}
                >
                  <TextArea
                    rows={8}
                    placeholder="Some pros and cons after using the product or other thoughts vou would like to share with others. Reviews must be more than 100 characters."
                  />
                </Form.Item>
                <div className={styles['form-tip']} style={{ color: '#D70B17' }}>Notice: Reviews must be more than 100 characters!</div>
              </div>

              <div className={styles['review-form-label']} style={{ width: '100%', marginBottom: 16, marginTop: 8 }}>{'(Optional) Add pictures about the products'} <span style={{ color: '#D70B17' }}>{'for additional 100 CrazyPoints ($1)'}</span></div>
              <Form.Item
                name="images"
              >
                <CustomUpload maxCount={9} maxSize={5} data={{ productID: params ? params[0] : "" }} />
              </Form.Item>

              <div className={styles['review-form-label']} style={{ width: '100%', marginBottom: 16, marginTop: 28 }}>Would you recommend this product to your friends?</div>
              <Form.Item
                name="recommend"
              >
                <Radio.Group >
                  <Radio value={1}>Yes</Radio>
                  <Radio value={0}>No</Radio>
                </Radio.Group>
              </Form.Item>
            </div>

            <div className={styles['form-config']}>
              <div className={styles['form-config-title']}>By clicking submit you agree to the
                <Link href={'/review-conditions'} legacyBehavior>
                  <a rel="noopener noreferrer" target={"_blank"} className={styles['termsAndConditions']}>
                    Terms and Conditions
                  </a>
                </Link>
                <span className={styles['red']}>*Please Check</span>
              </div>
              <div className={styles['form-submit']}>
                <Button href={orderInfo.url} type="primary" ghost >Cancel</Button>
                <Button type="primary" htmlType="submit" loading={loading} style={{ marginLeft: 54 }}>Submit</Button>
              </div>
            </div>
          </Form>
        </div>
      </div >
    </div >
  )
}

const RefuseReviews = () => {
  return (
    <div className={refuseStyles['main']}>
      <div className={refuseStyles['submit-save']}>
        <Image src={`${imageDomain}/NoReviews.png`} width={224} height={137} alt="Thank you" preview={false} />
        <h1 className={refuseStyles['submit-save-title']}>Sorry!</h1>
        <p className={refuseStyles['submit-save-text']}>
          We only accept reviews from customers who have bought and<br />
          received this product from CrazySales.
        </p>
        <Button href="/" type="primary" style={{ width: '224px' }} >Continue Shopping</Button>
      </div>
    </div>
  )
}

/**
 * 自定义上传组件
 *
 * @param value 上传文件的初始列表
 * @param onChange 文件列表变化时的回调函数
 * @param maxCount 允许上传的最大文件数量，默认为5
 * @param maxSize 允许上传的文件最大大小（以MB为单位），默认为2MB
 * @param data 上传时附带的额外数据
 * @returns 自定义上传组件
 */
const CustomUpload = ({ value = [], onChange, maxCount = 5, maxSize = 2, data = {} }: any) => {
  const [fileList, setFileList] = useState(value);
  const [loading, setLoading] = useState(false);

  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(event.target.files || []);
    const newFiles: { name: string; value: any }[] = [];

    const showError = (msg: string) => message.error(msg);

    try {
      for (const file of files) {
        const isImage = file.type.startsWith("image/");
        if (!isImage) {
          showError(`${file.name} is not a valid image format!`);
          continue;
        }

        const isLtMaxSize = file.size / 1024 / 1024 < maxSize;
        if (!isLtMaxSize) {
          showError(`${file.name} exceeds the ${maxSize}MB limit!`);
          continue;
        }

        setLoading(true);

        const formData = new FormData();
        formData.append('photo', file);
        Object.entries(data).forEach(([key, value]: any) => {
          formData.append(key, value);
        });

        const headers = new Headers({
          Authorization: localStorageService.getItem('userToken') || "",
        });

        const response = await fetch(`${apiDomain}/api/v1/upload/img/review`, {
          headers,
          method: 'POST',
          body: formData,
        });

        if (response.ok) {
          const result = await response.json();
          if (result.code === 100000) {
            newFiles.push({ name: file.name, value: result.data.uploadImg });
          } else {
            showError(result.message);
          }
        } else {
          showError('Upload failed');
        }
      }
    } catch (error: any) {
      showError(error.message);
    } finally {
      setLoading(false);
    }

    const updatedFileList = [...fileList, ...newFiles].slice(0, maxCount);
    setFileList(updatedFileList);

    if (onChange) {
      onChange(updatedFileList);
    }

    // Clear input value to allow re-selection of the same file
    event.target.value = "";
  };

  const handleRemove = (index: number) => {
    const updatedFileList = fileList.filter((_: any, i: number) => i !== index);
    setFileList(updatedFileList);

    if (onChange) {
      onChange(updatedFileList);
    }
  };

  return (
    <Row>
      <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
        {fileList.map((file: any, index: number) => (
          <div
            key={index}
            style={{
              position: "relative",
              width: "160px",
              height: "160px",
              border: "1px solid #ddd",
              overflow: "hidden",
              marginRight: "10px",
              background: `url(https://img.crazysales.com.au${file.value.normal}) no-repeat center/cover`,
            }}
          >
            <Button
              type="text"
              size="small"
              style={{
                position: "absolute",
                top: "0",
                right: "0",
              }}
              onClick={() => handleRemove(index)}
            >
              <CloseOutlined />
            </Button>
          </div>
        ))}
        {fileList.length < maxCount && (
          <div style={{ width: '160px', height: '160px', border: "1px solid #ddd", padding: '14px', boxSizing: "border-box", position: 'relative' }}>
            <input
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              multiple
              style={{ display: "none" }}
              id="custom-upload"
            />
            <div onClick={() => document.getElementById("custom-upload")?.click()} style={{ width: '100%', height: '100%', cursor: 'pointer', background: '#DDDDDD', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Button type="primary" loading={loading} style={{ width: '80px', height: '32px', padding: 0, fontSize: '16px', fontWeight: 'bold' }}>
                Add
              </Button>
            </div>
            <div style={{ position: 'absolute', left: '0', top: '100%', fontSize: '14px', whiteSpace: 'nowrap', color: '#D70B17' }}>{'(Image size must be between 30KB-5MB.)'}</div>
          </div>
        )}
      </div>
    </Row>
  );
};